export class PageRequest {
  page?: number;
  itensPerPage?: number;
  filters?: Map<string, string>;
  orderBy?: string;
  orderByDirection?: string;
}
